import type { PlanComparisonCellValue } from "./types.js";

export type ComparisonTranslate = (
  key: string,
  options?: Record<string, string | number>,
) => string;

/**
 * Formats a structured comparison cell for display.
 * Uses i18n keys passed via the translate callback.
 */
export function formatPlanComparisonCellValue(
  value: PlanComparisonCellValue,
  t: ComparisonTranslate,
): string {
  switch (value.kind) {
    case "included":
      return t("planComparison.values.included");
    case "excluded":
      return t("planComparison.values.excluded");
    case "unlimited":
      return t("planComparison.values.unlimited");
    case "limit":
      return t("planComparison.values.perMonthLimit", { count: value.value ?? 0 });
    case "text":
      return value.textKey ? t(value.textKey) : "";
    default:
      return "";
  }
}

export function planComparisonCellIsPositive(value: PlanComparisonCellValue): boolean {
  return value.kind === "included" || value.kind === "unlimited" || value.kind === "limit" || value.kind === "text";
}
